import React, { Component } from "react";
import { CSSTransition } from "react-transition-group";
import styleObj from "./style.module.scss";

export default class Banner2021 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      init: false,
    };
  }
  render() {
    let { init } = this.state;
    let { cover, meta } = this.props;
    return (
      <div className={styleObj["banner-wrap"]}>
        <div className={styleObj["banner"]}>
          <CSSTransition
            in={init}
            classNames="fade"
            timeout={1200}
            unmountOnExit
          >
            <img src={`//s2.jiguo.com/${cover}`} alt="" />
          </CSSTransition>
        </div>
        <div className={styleObj["denglong-l"]}></div>
        <div className={styleObj["denglong-r"]}></div>
        <div className={styleObj["xiangyun-l"]}></div>
        <div className={styleObj["xiangyun-r"]}></div>
      </div>
    );
  }
  componentDidMount() {
    this.setState({ init: true });
  }
}
